import React, { useState } from "react";
import { StyledCardStack } from "./styles";
import classNames from "classnames";

export default function EDUCardsSB({ fullWidth, updateHideEDUCards, subscription, loadSampleStory }) {
  const ulClasses = classNames({
    "full-width": fullWidth,
  });

  const number_of_cards = 3;

  const CommunityCard = (
    <li className="card">
      <h3>Join the Community!</h3>
      <p>Learn from our friendly community of AI-assisted writers. The Sudowrite Discord is the ultimate source of feedback, help, and&nbsp;advice.</p>
      <a
        className="rainbow1"
        href="https://discord.gg/z9b3N4gyUM" // TODO: make sure this is correct link
        target="_blank"
        rel="noreferrer"
        aria-label="Join the Sudowrite Discord"
      >
        Join {"->"}
      </a>
    </li>
  );

  const LiveClassesCard = (
    //use &nbsp; between penultimate and last words to prevent widows - a typography issue where a word appears on a line by itself.
    <li className="card">
      <h3>Attend a live class</h3>
      <p>Get answers to your questions from AI writing experts. There's a class for every skill level, from Beginner to&nbsp;Advanced.</p>
      <a
        className="orange"
        href="https://lu.ma/sudowrite/?utm_source=EDU_cards"
        target="_blank"
        rel="noreferrer"
        aria-label="Sign up for a live Sudowrite class"
      >
        Sign up {"->"}
      </a>
    </li>
  );

  const SampleProjectCard = (
    <li className="card">
      <h3>Try out an example project</h3>
      <p>Go hands-on with a Sudowrite demo by experimenting in this sample&nbsp;project.</p>
      <a
        className="rainbow3"
        href="#"
        target="_blank"
        rel="noreferrer"
        aria-label="Open a sample project"
        onClick={(e) => {
          e.preventDefault();
          loadSampleStory();
        }}
      >
        Open sample {"->"}
      </a>
    </li>
  );

  const DocumentationCard = (
    <li className="card">
      <h3>Read the Docs</h3>
      <p>If you're the type that reads the manual, check out our documentation covering all of Sudowrite's features and how they&nbsp;work.</p>
      <a
        className="rainbow3"
        href="#" // TODO: get link to docs
        target="_blank"
        rel="noreferrer"
      >
        Open docs {"->"}
      </a>
    </li>
  );

  const VideoCard = (
    <li className="card">
      <h3>View our video library</h3>
      <p>As they say, show, not tell! Watch our videos and learn how to get the most out of&nbsp;Sudowrite.</p>
      <a
        className="rainbow3"
        href="#" // TODO: get link to video library
        target="_blank"
        rel="noreferrer"
      >
        Watch {"->"}
      </a>
    </li>
  );

  const cards = [CommunityCard, LiveClassesCard, SampleProjectCard];

  const [showCards, setShowCards] = useState(true);

  if (!subscription) {
    return null;
  }

  return (
    <StyledCardStack>
      <ul className={ulClasses}>
        {showCards && (
          <>
            {cards.map((card, i) => {
              // apply unique keys by cloning and overriding key prop
              return React.cloneElement(card, { key: i });
            })}
          </>
        )}
        {showCards && (
          <li className="hide-button">
            <button
              onClick={(e) => {
                setShowCards(false);
                updateHideEDUCards(true);
              }}
            >
              Don't show these again
            </button>
          </li>
        )}
      </ul>
    </StyledCardStack>
  );
}
